<div
  class="container book-tele-container"
  style="background: white !important"
  *ngIf="home"
>
  <div class="left-section">
    <div class="centered-content">
      <h2>Sick or Worried About Symptoms ?</h2>
      <h2 class="tagline" style="font-size: 18px">
        Get Instant Medical Advice from Trusted Professionals
      </h2>
    </div>
    <img
      src="../../../../assets/Images/new-images/docter.webp"
      alt="Ambulance"
      class="ambulance-img"
    />
  </div>
  <div class="right-section">
    <div
      id="add_tele"
      class="modal fade custom-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form
            [formGroup]="teleMedicineConsultForm"
            (ngSubmit)="consultationBooking()"
            class="book-consultation-form p-4"
          >
            <div
              class="modal-header"
              style="padding: 0px; border: none; padding-bottom: 10px"
            >
              <h4 class="mb-3">Book Consultation</h4>
            </div>

            <div class="form-group mb-3">
              <label
                >Select Consultation Type
                <span class="text-danger">*</span></label
              >
              <select
                class="form-select form-control"
                formControlName="consultation_type"
              >
                <option [ngValue]="null" disabled>Select</option>
                <option>Consult with General Physician</option>
              </select>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('consultation_type')?.touched &&
                  teleMedicineConsultForm.get('consultation_type')?.invalid
                "
                class="text-danger"
              >
                Consultation type is required.
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Select Patient <span class="text-danger">*</span></label>
              <select
                id="patient-select"
                class="form-select form-control"
                formControlName="patient"
                (change)="onPatientChange('telemedi')"
              >
                <option [ngValue]="null" disabled>Select Patient</option>
                <option *ngFor="let patient of patientList" [ngValue]="patient">
                  {{ patient.first_name + " " + patient.last_name }}
                </option>
              </select>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('patient')?.touched &&
                  teleMedicineConsultForm.get('patient')?.invalid
                "
                class="text-danger"
              >
                Patient is required.
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Age <span class="text-danger">*</span></label>

              <input
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="3"
                class="form-control"
                formControlName="age"
                placeholder="eg. 24"
                (keypress)="blockInvalidKeys($event)"
                (paste)="blockInvalidPaste($event)"
                (input)="validateAge()"
              />

              <div
                *ngIf="ageCtrl?.enabled && ageCtrl?.touched && ageCtrl?.invalid"
              >
                <div *ngIf="ageCtrl?.hasError('required')" class="text-danger">
                  Age is required.
                </div>
                <div *ngIf="ageCtrl?.hasError('min')" class="text-danger">
                  Age must be 18 or above
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Gender <span class="text-danger">*</span></label>
              <select class="form-control" formControlName="gender">
                <option value="" disabled>Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('gender')?.touched &&
                  teleMedicineConsultForm.get('gender')?.invalid
                "
                class="text-danger"
              >
                Gender is required.
              </div>
            </div>
            <div *ngIf="alaCartPriceOption == false || completeTelemedSub">
              <div class="form-group mb-3">
                <label>Currency <span class="text-danger">*</span></label>
                <select
                  class="form-select form-control"
                  (change)="getCurrencyPrice()"
                  formControlName="currency"
                >
                  <option value="" disabled>Select</option>
                  <option value="USD">USD</option>
                  <option value="ZWG">ZWG</option>
                </select>
                <div
                  *ngIf="
                    teleMedicineConsultForm.get('currency')?.touched &&
                    teleMedicineConsultForm.get('currency')?.invalid
                  "
                  class="text-danger"
                >
                  Currency is required.
                </div>
              </div>
              <div class="form-group mb-3" *ngIf="currencyPrice > 0">
                <label>Price <span class="text-danger">*</span></label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="a_la_carte_price"
                  placeholder="eg. 24"
                />
                <div
                  *ngIf="
                    teleMedicineConsultForm.get('a_la_carte_price')?.touched &&
                    teleMedicineConsultForm.get('a_la_carte_price')?.invalid
                  "
                  class="text-danger"
                >
                  Price is required.
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Phone Number <span class="text-danger">*</span></label>
              <ngx-intl-tel-input
                class="custom_imput custom_imput_disabled"
                [inputId]="'phone-input'"
                [cssClass]="'custom'"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="false"
                [searchCountryFlag]="true"
                [customPlaceholder]="'Enter Phone Number'"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name,
                ]"
                [selectFirstCountry]="true"
                [selectedCountryISO]="CountryISO.Zimbabwe"
                [separateDialCode]="true"
                [maxLength]="15"
                (input)="onPhoneInput($event)"
                [phoneValidation]="true"
                name="phone"
                formControlName="phone"
              >
              </ngx-intl-tel-input>
              <div
                *ngIf="teleMedicineConsultForm.get('phone')?.touched"
                class="text-danger mt-1"
              >
                <div
                  *ngIf="teleMedicineConsultForm.get('phone')?.errors?.required"
                >
                  Phone Number is required.
                </div>
                <div
                  *ngIf="
                    !teleMedicineConsultForm.get('phone')?.errors?.required &&
                    teleMedicineConsultForm.get('phone')?.errors
                      ?.invalidZimbabweMobile
                  "
                >
                  Invalid Zimbabwe phone number
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label
                >Reason For Consultation
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="reason_for_consultation"
                placeholder="eg. Suffering Fever"
              />
              <div
                *ngIf="
                  teleMedicineConsultForm.get('reason_for_consultation')
                    ?.touched &&
                  teleMedicineConsultForm.get('reason_for_consultation')
                    ?.invalid
                "
                class="text-danger"
              >
                Reason for consultation is required.
              </div>
            </div>
            <div class="form-group mb-3">
              <label
                >Plan Your Consultation
                <span class="text-danger">*</span></label
              >
              <select
                class="form-select form-control"
                formControlName="plan_consultation"
              >
                <option [ngValue]="null" disabled>Select</option>
                <option value="Scheduled">Schedule</option>
                <option value="Consult Now">Consult Now</option>
              </select>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('plan_consultation')?.touched &&
                  teleMedicineConsultForm.get('plan_consultation')?.invalid
                "
                class="text-danger"
              >
                Consultation is required.
              </div>
            </div>

            <div
              class="form-group mb-3"
              *ngIf="
                teleMedicineConsultForm.get('plan_consultation')?.value !==
                'Consult Now'
              "
            >
              <label
                >Appointment Date & Slots
                <span class="text-danger">*</span></label
              >
              <div class="d-flex gap-2">
                <div class="w-50">
                  <div class="position-relative">
                    <input
                      #dp="bsDatepicker"
                      type="text"
                      class="form-control"
                      bsDatepicker
                      placement="top"
                      placeholder="Select Date"
                      formControlName="appointment_date"
                      (bsValueChange)="getSlotsData($event)"
                      [minDate]="minDate"
                      [outsideClick]="true"
                      [maxDate]="maxDate"
                      [bsConfig]="bsDatepickerConfig"
                      inputmode="none"
                      readonly
                      onkeydown="return false;"
                    />
                    <i
                      class="fa-regular fa-calendar position-absolute"
                      (click)="dp.toggle()"
                    ></i>
                  </div>
                  <div
                    *ngIf="
                      teleMedicineConsultForm.get('appointment_date')
                        ?.touched &&
                      teleMedicineConsultForm.get('appointment_date')?.invalid
                    "
                    class="text-danger"
                  >
                    Date is required.
                  </div>
                </div>

                <div class="w-50">
                  <select
                    class="form-select form-control"
                    [disabled]="slotsList.length > 0"
                    formControlName="slot_id"
                  >
                    <option [ngValue]="null" disabled>Select Slot</option>
                    <option
                      *ngFor="let list of slotsList"
                      [ngValue]="list.slot_id"
                    >
                      {{ list.slots }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      teleMedicineConsultForm.get('slot_id')?.touched &&
                      teleMedicineConsultForm.get('slot_id')?.invalid
                    "
                    class="text-danger"
                  >
                    Slot is required.
                  </div>
                </div>
              </div>
            </div>

            <!-- select medical records -->
            <div class="form-group mb-3">
              <label>Add Medical Records</label>

              <ng-select
                [items]="unlockMedicalList"
                bindLabel="displayText"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                [searchable]="true"
                placeholder="Select Medical Records"
                formControlName="medical_report_id"
              >
              </ng-select>
            </div>

            <div
              class="form-group note-card mb-3"
              *ngIf="alaCartPriceOption === false"
            >
              <div class="note-header">Note -</div>
              <div class="note-body">
                {{ constant.CONSULTANT_NOTE }}
              </div>
            </div>
            <div class="form-group note-card mb-3" *ngIf="alaCartPriceOption">
              <div class="note-header">Note -</div>
              <div class="note-body">
                {{
                  completeTelemedSub
                    ? constant.CONSULTANT_NOTE
                    : "You have used " +
                      subTelemedCount +
                      " out of 12 consultations this year."
                }}
              </div>
            </div>

            <div class="form-group custom-center">
              <button type="submit" class="add-new-btn book_btn button_class">
                Book Consultation
              </button>
              <button
                type="button"
                id="book"
                class="d-none"
                data-bs-dismiss="modal"
              ></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="payment-summary" *ngIf="proceedToPay">
  <div class="summary-box">
    <button class="close-btn cross" (click)="closeApology()">×</button>
    <h2>Summary</h2>
    <p>
      <strong>Name:</strong>
      {{
        paymentStatus?.patient?.first_name +
          " " +
          paymentStatus?.patient?.last_name || "Not available"
      }}
    </p>
    <p>
      <strong>Number:</strong> +263 {{ paymentStatus?.patient?.phone || "N/A" }}
    </p>
    <p>
      <strong>Date:</strong>
      {{
        paymentStatus?.booking_date
          ? (paymentStatus?.booking_date | date: "dd/MM/yy")
          : "Not selected"
      }}
    </p>
    <p>
      <strong>Slot:</strong>
      {{ paymentStatus?.booking_time ? paymentStatus.booking_time : "Not set" }}
    </p>
    <p>
      <strong>Reason for Consultation:</strong>
      {{ paymentStatus?.reason_for_consultation || "N/A" }}
    </p>
    <p *ngIf="alaCartPriceOption == false || completeTelemedSub">
      <strong>Consultation Charges:</strong>
      {{
        paymentStatus?.currency + " " + paymentStatus?.a_la_carte_price || "N/A"
      }}
    </p>

    <div class="button-group">
      <button class="btn back" (click)="back()">Back</button>
      <button class="btn confirm button_class" (click)="onCheckEl()">
        {{ notEligiblie || completeTelemedSub ? "Confirm & Pay" : "Confirm" }}
      </button>
    </div>
  </div>
</div>

<div class="booking-success" *ngIf="bookingConfirmed === 'success'">
  <div class="success-box">
    <img
      src="../../../../assets/img/check-mark-removebg-preview.png"
      alt="Success"
      class="success-icon"
    />
    <h2>Payment Successful!!</h2>
    <p>Your booking is confirmed, our docter will contact you shortly!!</p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="payment-summary">
  <div
    class="ecocash-pin-container"
    *ngIf="enterEcocashPIn"
    [formGroup]="pinForm"
  >
    <h3>
      Current Ecocash Number: <b>{{ billingNumber }}</b>
    </h3>
    <h2>Please enter your EcoCash pin:</h2>
    <div class="pin-inputs">
      <input
        #pinInput
        type="text"
        maxlength="1"
        *ngFor="let control of [0, 1, 2, 3]; let i = index"
        [formControlName]="'pin' + i"
        (input)="onInput(i, $event)"
        (keypress)="allowOnlyDigits($event)"
        (keydown)="onKeyDown(i, $event)"
      />
      <button type="button" class="eye-btn" (click)="togglePinVisibility()">
        <i class="fa" [ngClass]="showPin ? 'fa-eye-slash' : 'fa-eye'"></i>
      </button>
    </div>
    <div
      class="error-message pin-error"
      *ngIf="pinForm.invalid && pinForm.touched"
    >
      Please enter all 4 digits of your EcoCash PIN.
    </div>

    <button
      class="custom-back-button"
      (click)="this.enterEcocashPIn = false; this.proceedToPay = true"
    >
      Back
    </button>
    <button class="confirm-btn button_class" (click)="onSubmit()">
      Confirm
    </button>
  </div>
</div>

<div class="booking-success" *ngIf="bookingConfirmed === 'failed'">
  <div class="error-box">
    <img
      src="../../../../assets/icons\notification-icons/warning.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Payment Failed</h2>
    <p>
      {{ remark }}
    </p>

    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="booking-success" *ngIf="bookingConfirmed === 'progress'">
  <div class="error-box">
    <img
      src="../../../../assets/img/check-mark-removebg-preview.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Payment In Progress</h2>
    <p>Your payment is being processed. Please wait a few moments.</p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="error-container">
  <div
    class="error-box"
    *ngIf="IncorrectPin && (attemptsLeft === 2 || attemptsLeft === 1)"
  >
    <img
      src="../../../../assets/img/stop.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Incorrect PIN</h2>
    <p *ngIf="attemptsLeft === 2">
      Invalid mobile number or PIN. Please check and try again.
    </p>
    <p *ngIf="attemptsLeft === 1">
      The PIN you have entered is Incorrect. On the next unsuccessful attempt,
      you will be blocked.
    </p>
    <button (click)="proceedToPays()" class="proceed-btn button_class">
      Proceed to pay
    </button>
  </div>

  <div *ngIf="ErrorPin && statusCode === '99033'">
    <app-add-alternate-number
      (triggerMoveToHome)="moveToHomeScreen()"
      (triggerOtpSuccess)="proceedToPays($event)"
    ></app-add-alternate-number>
  </div>

  <div
    class="error-box"
    *ngIf="ErrorPin && statusCode !== '99033'"
    [ngSwitch]="statusCode"
  >
    <img
      src="../../../../assets/icons\notification-icons/warning.png"
      alt="Error Icon"
      class="error-icon"
    />
    <h2>Payment Failed</h2>
    <p *ngSwitchCase="20005">
      Your account is currently blocked. Please reset your PIN or contact
      Customer Care for help.
    </p>
    <p *ngSwitchCase="002100">
      {{ errorMessage }}
    </p>
    <p *ngSwitchDefault>Please try again later, sorry for the inconvenience</p>
    <a (click)="moveToHomeScreen()" class="retry-link button_class"
      ><span class="text-white class">Tap here</span> to try again</a
    >
  </div>
</div>

<div class="booking-succes" id="popupModal" *ngIf="onHoldPopup">
  <div class="error-box">
    <h2>⏳ Hold On! You're Almost There</h2>
    <p>
      You have already exhausted your 12 consultations for this year under your
      subscription plan. To continue, please proceed with an A-la-carte
      consultation.
    </p>
    <button class="custom-back-button" (click)="onHoldPopup = false">
      Cancel
    </button>
    <button
      class="confirm-btn button_class"
      (click)="onBookingTelemedicineConsultant()"
    >
      Continue
    </button>
  </div>
</div>

<!-- Slot Modal -->
<div class="payment_summary_modal" *ngIf="slotUnavailable">
  <div class="summary-box pay-summary">
    <div class="slot-img-container">
      <img
        src="../../../../assets/img/unavailable-slot.webp"
        class="slot-icon"
        alt="unavailable"
      />
    </div>

    <button class="close-btn cross" (click)="this.slotUnavailable = false">
      ×
    </button>
    <div class="slot-unavailable">Slot Unavailable</div>

    <p>
      The consultation slot you selected is no longer available as it has
      already been booked by other patient. Please choose a different slot to
      continue with your booking.
    </p>
    <div class="button-okay summary-btns">
      <button class="btn confirm button_class" (click)="closeProceedPayment()">
        Okay
      </button>
    </div>
  </div>
</div>
